import type { FC, ReactNode } from 'react';
import React from 'react';

import styled from '@emotion/styled';

import { Box, FontWeight, SERIF_FONT_FAMILY, Text } from '@clutter/clean';

const LeftQuote = styled.div`
  font-family: ${SERIF_FONT_FAMILY};
  transform: translate(-8px, -8px);
  font-size: 40px;
`;

const RightQuote = styled.div`
  font-family: ${SERIF_FONT_FAMILY};
  font-size: 40px;
  line-height: 0;
  transform: translate(8px, 8px);
`;

export const ReviewCard: FC<{
  title?: ReactNode;
  quote: ReactNode;
  reviewer: ReactNode;
}> = ({ title, quote, reviewer }) => (
  <Box
    width="100%"
    maxWidth="480px"
    minWidth="240px"
    margin="0 auto"
    padding="0 8px"
    textAlign="center"
  >
    {title && <Text.Title size="small">{title}</Text.Title>}
    <Box.Flex position="relative" padding="24px 0 0">
      <LeftQuote>“</LeftQuote>
      <Text.Body>{quote}</Text.Body>
      <Box.FlexItem alignSelf="flex-end">
        <RightQuote>”</RightQuote>
      </Box.FlexItem>
    </Box.Flex>
    <Text.Body weight={FontWeight.Medium}>{reviewer}</Text.Body>
  </Box>
);
